<div class="pme-container">

  <!-- Pendente configurar o hero padrão -->
  <!-- Título: Seja um cliente Premium! -->
  <!-- Descrição: <p>Aproveite os <span class="pme-success-text">10% de desconto</span> e comece já a monitorar os seus sócios. Pagando com boleto, seu desconto é ainda maior.</p> -->
  <div class="display-utils-col display-utils-gt-sm-row display-utils-center">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showErrorHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}"
        showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
        redirectURL="{{this.heroData.redirectURL}}">
        <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
      </pme-hero>
    </div>
  </div>
  <div class="pme-col display-utils-row display-utils-left display-utils-hide-gt-sm">

    <h2 class="mat-subheading-2 serasa-color-title upgradeTitle"
      *ngIf="!showErrorHero && classificationIdentifier !== 'plano-mensal'">
      Upgrade de plano</h2>

    <h2 class="mat-subheading-2 serasa-color-title"
      *ngIf="!showErrorHero && classificationIdentifier === 'plano-mensal'">
      Alteração de plano</h2>
  </div>
  <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-60">
    <div class="pme-col padding-right display-utils-gt-sm-flex-65" >
      <main>
        <div *ngIf="!this.showErrorHero">
          <h2 class="mat-subheading-2 serasa-color-title display-utils-hide-lt-md"
            *ngIf="!showErrorHero && classificationIdentifier !== 'plano-mensal'">Upgrade de plano
          </h2>

          <h2 class="mat-subheading-2 serasa-color-title display-utils-hide-lt-md"
            *ngIf="!showErrorHero && classificationIdentifier === 'plano-mensal'">
            Alteração de plano</h2>

          <div *ngIf="isMobile">
            <pme-mobile-dropdown class="display-utils-gt-sm-flex-35">
              <p title class="color-blue-buy">Resumo do plano</p>
              <div content class="pme-col" *ngIf="!this.showErrorHero" >
                <aside *ngIf="showData">
      
                  <!-- New product choice -->
      
                  <pme-product-choice *ngIf="this.selfAttendanceData" [cardTitle]="'Plano atual'"
                    [productName]="this.selfAttendanceData.contract.product.name"
                    [totalValue]="this.selfAttendanceData.contract.product.value"
                    [newProduct]="this.selfAttendanceData.upgradeData.product" [shopWindowLink]="this.returnUrl"
                    [startSubscription]="this.selfAttendanceData.contract.saleDate"
                    [endSubscription]="this.selfAttendanceData.contract.endDate">
      
                  </pme-product-choice>
                  <div>
                    <pme-cart (cartUpdated)="this.handleCartUpdate()" [isUpgrade]="true"
                      [redirectUrl]="this.redirectUrl"></pme-cart>
                  </div>
                </aside>
              </div>
            </pme-mobile-dropdown>
          </div>
          
          <!-- Formulario de pagamento -->
          <div>
            <div>
              <pme-payment-form *ngIf="this.showPaymentForm" 
                [buttonName]="this.buttonName"
                [paymentOptions]="this.paymentOptions" 
                [termOfUse]="this.cart.tdu"
                [discountBadge]="this.discountBadge"
                [creditCardData]="this.creditCardData"
                [creditCardsData]="this.creditCardsData" 
                [maxLimitCreditCards]="maxLimitCreditCards"
                [context]="'UPGRADE'"
                [suggestionMessage]="this.suggestionMessage"
                [isACreditCardError]="this.isACreditCardError"
                [adyenCardError]="this.adyenCardError"
                (paymentConditionSelected)="onPaymentConditionSelected($event)" 
                (formSubmitted)="onSubmit($event)" 
                (paymentMethodSelected)="onPaymentMethodSelected($event)"
                (deleteCreditCard)="handleDeleteCreditCard($event)" >
              </pme-payment-form>
              <!-- <pme-payment-form *ngIf="this.showPaymentForm" [buttonName]="this.buttonName" [paymentOptions]="this.paymentOptions"
                [creditCardData]="this.creditCardData" [redirectUrl]="this.redirectUrl" [returnUrl]="this.returnUrl"
                [termOfUse]="this.cart.tdu" [context]="'UPGRADE'" [discountBadge]="this.discountBadge"
                (formSubmitted)="onSubmit($event)" (paymentConditionSelected)="onPaymentConditionSelected($event)"
                (paymentMethodSelected)="onPaymentMethodSelected($event)">
              </pme-payment-form> -->
            </div>
          </div>
        </div>
      </main>
    </div>

    <ng-container *ngIf="!isMobile">
      <pme-mobile-dropdown class="display-utils-gt-sm-flex-35">
        <p title class="color-blue-buy">Resumo do plano</p>
        <div content class="pme-col" *ngIf="!this.showErrorHero" >
          <aside *ngIf="showData">

            <!-- New product choice -->

            <pme-product-choice *ngIf="this.selfAttendanceData" [cardTitle]="'Plano atual'"
              [productName]="this.selfAttendanceData.contract.product.name"
              [totalValue]="this.selfAttendanceData.contract.product.value"
              [newProduct]="this.selfAttendanceData.upgradeData.product" [shopWindowLink]="this.returnUrl"
              [startSubscription]="this.selfAttendanceData.contract.saleDate"
              [endSubscription]="this.selfAttendanceData.contract.endDate">

            </pme-product-choice>
            <div>
              <pme-cart (cartUpdated)="this.handleCartUpdate()" [isUpgrade]="true"
                [redirectUrl]="this.redirectUrl"></pme-cart>
            </div>
          </aside>
        </div>
      </pme-mobile-dropdown>
    </ng-container>
    
  </div>
</div>